import { EMPTY } from '~/utils/constants'

export default {
  namespaced: true,
  state: () => ({
    /* Images data */
    roleName: EMPTY
  }),
  mutations: {
    setData(state, payload) {
      Object.keys(payload).forEach(key => {
        if (state[key] !== undefined) {
          state[key] = payload[key]
        } 
      })
    },
    setUserRole(state, payload) {
      state.roleName = payload
    }
  },
}
